import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { CollectionSelectOptions, CollectionType } from '@/modules/collection/types';
import { collectionService } from '@/services/collection';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

export function useCollectionList(collectionType: CollectionType) {
    const route = useRoute();
    const { confirmAndExecute } = useCrudActions();
    const isJourney = collectionType == CollectionType.Journey;
    const selectedType = ref(collectionType || StringUtils.toNumber(route.query.type) || CollectionType.Theme);

    const { list, total, fetchList } = useBaseListView({
        request: collectionService.list,
        paramsBuilder: () => ({ type: selectedType.value })
    });

    const selectableTypeOptions = computed(() =>
        isJourney
            ? CollectionSelectOptions.Type.filter(item => item.value === CollectionType.Journey)
            : CollectionSelectOptions.Type.filter(item => item.value !== CollectionType.Journey)
    );

    const actions = {
        publish: confirmAndExecute({
            confirmMessage: 'Are you sure you want to publish this item?',
            request: collectionService.publish,
            onSuccess: () => fetchList()
        }),
        unpublish: confirmAndExecute({
            confirmMessage: 'Are you sure you want to unpublish this item?',
            request: collectionService.unpublish,
            onSuccess: () => fetchList()
        }),
        remove: confirmAndExecute({
            confirmMessage: 'Are you sure you want to remove this item?',
            request: collectionService.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, selectedType, actions, isJourney, selectableTypeOptions };
}
